import styled from 'styled-components';

export const PriceAmount = styled.div`
    color: #000000;
    font-family: "Jost", sans-serif;
    font-size:14px;
    font-weight: 500;
    line-height: 20px;
    background: rgb(51 167 174 / 10%) ;
    box-shadow: 0px 5px 10px #0000000D;
    border-radius: 10px;
    padding: 15px 14px;
    display:inline-flex;
    width: 100%;
    max-width: 56px;
    justify-content: center;
    cursor: pointer;
    
    &.active,
    &:hover{
     background:#01606F;
     color: #fff;
    }

`;

export const PriceWarapper = styled.div`
    display: flex;
    gap: 10px;

   
    
`;
